/**
 * MSAL Instance
 * Singleton PublicClientApplication for Azure AD authentication
 * Note: MsalProvider handles initialize() and handleRedirectPromise() internally.
 * We only register event callbacks here to set the active account.
 */

import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from '@azure/msal-browser';
import { msalConfig } from './authConfig';

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Register event callback to set active account on login
msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(payload.account);
  }
  if (event.eventType === EventType.LOGIN_FAILURE) {
    console.error('Login failed:', event.error);
  }
});
